/** 上报的模块 */
export enum EReportModule {
  Api = '请求',
  Global = '全局',
}
